import { inputCommon } from '../inputCommon'
import type { FieldInputProps } from '../types'

export function TextareaInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <textarea
      id={`field-${field.fieldCode}`}
      className={`${inputCommon(disabled)} min-h-[6rem]`}
      disabled={disabled}
      value={value === null || value === undefined ? '' : String(value)}
      onChange={e => onChange(e.target.value)}
    />
  )
}
